<template>
  <div class="add-block-wrap" :class="$store.state.editor.device">
    <template v-if="menuInfo.draggable || isFooterWidget">
      <div v-if="$store.getters.isDesktop">
        <div class="add-block-opener" @click.stop.prevent="handleShowAddBlock">
          <button class="add-block-opener__btn">
            <add-svg />
            <span class="ml-8px">{{ $t('添加区块') }}</span>
          </button>
        </div>
      </div>
      <template v-else>
        <div slot="reference" class="add-block-opener-mobile" @click.stop.prevent="handleShowAddBlock">
          <button class="add-block-opener-mobile__btn">
            <i class="el-icon-plus"></i>
          </button>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es'
import { Message } from 'element-ui'
import addSvg from '~/assets/svg/icon/add-green.svg?inline'
import { insertReduceStep } from '~/utils/event'
import { scrollToWidget } from '~/site/core'
import { DialogCollectionWidgetModel } from '~/site/model/models/DialogCollectionWidgetModel'
import { ModuleTitleEnum, WidgetModelNames } from '~/enums/siteEnum'
export default {
  components: {
    addSvg,
  },
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    canDrag: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    widget: {
      type: Object,
      default() {
        return {
          getMenuInfo() {
            return {
              draggable: true,
            }
          },
        }
      },
    },
    model: {
      type: Object,
      required: true,
      default() {
        return {
          getCanAddWidget() {},
        }
      },
    },
  },
  data() {
    return {
      WidgetModelNames,
      show: this.value,
      currentId: '',
    }
  },
  computed: {
    isFooterWidget() {
      return this.widget?.name === this.WidgetModelNames.FooterWidgetModel
    },
    hasDialogCollect() {
      return Boolean(this.model.widgetList.find((item) => item.name === DialogCollectionWidgetModel.moduleClass))
    },
    menuInfo() {
      return this.widget?.getMenuInfo() || {}
    },
  },
  methods: {
    checkAddWidget(item) {
      let result = true
      if (this.hasDialogCollect && item.title === ModuleTitleEnum.DialogCollection) {
        result = false
        Message.error('弹窗集模块只可添加一个，请勿重复添加')
      }
      return result
    },
    addWidgetByIndex(item) {
      if (!this.checkAddWidget(item)) return
      const index = this.index + 1
      let model
      if (item?.children?.length) {
        model = this.model.addWidgetByIndex(item.children[0].model, index)
      } else {
        model = this.model.addWidgetByIndex(item.model, index)
      }
      insertReduceStep(this, { element: cloneDeep(model), index })
      scrollToWidget(this, model, index)
      this.show = false
    },
    handleShowAddBlock() {
      // this.show = true
      this.$emit('show-add-block', this.index)
      this.$store.commit('editor/SET_CURRENT_MODEL', { id: this.widget.id })
    },
  },
}
</script>

<style lang="less">
.add-block-wrap.@{mobile} {
  .add-block-opener-mobile {
    position: absolute;
    top: -16px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 40;

    &__btn {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: var(--primary-color);
      border: 2px solid #fff;
      box-shadow: 0 4px 12px rgba(var(--primary-color-rgb), 0.4);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      cursor: pointer;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

      i {
        font-size: 16px;
        font-weight: bold;
      }

      &:active {
        transform: scale(0.9);
        box-shadow: 0 2px 6px rgba(var(--primary-color-rgb), 0.3);
      }
    }
  }

  .add-block-opener {
    top: -15px;
  }
}

.add-block-opener {
  width: 100%;
  position: absolute;
  top: -20px;
  left: 0;
  right: 0;
  z-index: 40;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 820px;
  margin: 0 auto;
  color: var(--text-color);
  text-transform: uppercase;
  cursor: pointer;
  border-radius: var(--border-radius-base);

  &__btn {
    // 尺寸与排版
    font-size: 13px;
    font-weight: 600;
    height: 32px;
    border-radius: 16px;
    padding: 0 16px;
    display: inline-flex;
    letter-spacing: 0.5px;
    align-items: center;
    gap: 6px;

    // 视觉与层次
    color: #fff;
    background: var(--primary-color);
    border: 1px solid rgba(255, 255, 255, 0.2); // 增加边框不透明度
    box-shadow: var(--shadow-md);
    backdrop-filter: blur(4px);

    // 动效与可用性
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    -webkit-tap-highlight-color: transparent;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(var(--primary-color-rgb), 0.4);
      background: var(--primary-color);
      filter: brightness(1.1);
      border-color: rgba(255, 255, 255, 0.3);
    }

    &:active {
      transform: translateY(0);
      box-shadow: var(--shadow-sm);
    }

    &:focus-visible {
      outline: none;
      box-shadow: 0 0 0 2px rgba(var(--primary-color-rgb), 0.3);
    }
  }
}

.add-block {
  width: 100%;
  text-align: center;
  height: 0;
  max-height: 0;
  box-sizing: border-box;
  overflow: hidden;
  opacity: 0;

  //transition: height 0.3s ease, max-height 0.3s ease;
  &.no-padding {
    padding: 0;
  }

  &__title {
    color: white;
  }

  &__items {
    display: flex;
    margin-top: 24px;
    padding: 0 24px 3rem 24px;
    align-items: center;
    overflow: auto;
    overflow-y: hidden;
    max-width: 100%;
  }

  &__item {
    cursor: pointer;
    opacity: 0.5;
    transition: opacity 0.2s ease;
    max-width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 80px;
    flex-shrink: 0;

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      opacity: 1;
    }

    &-img {
      width: 80px;
      height: 80px;
      background-color: rgba(255, 255, 255, 0.6);
      border-radius: 100%;
    }

    &-title {
      margin-top: 8px;
      text-align: center;
      font-size: 14px;
      color: white;
    }
  }

  &.add-block__open {
    height: 226px;
    max-height: 226px;
    background-color: @primary-1;
    opacity: 1;
  }
}
</style>
